import { useState, useEffect } from "react";
import iniciov from "assets/images/Iniciov.png";
import styles from "./ScrollToTop.module.css";

function ScrollToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 350);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleClick = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <button
      className={`${styles.btn} ${visible ? styles.visible : ""}`}
      onClick={handleClick}
      aria-label="Volver al inicio"
    >
      <img src={iniciov} alt="Inicio" className={styles.img} />
    </button>
  );
}

export default ScrollToTop;
